import React, { Component } from 'react';
import { connect } from 'react-redux';
import EditorsRoute from './EditorsRoute';
import ReadOnlyRoute from './ReadOnlyRoute';
import { STATE_LOGIN, STATE_SIGNUP } from 'components/AuthForm';
import GAListener from 'components/GAListener';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import PageSpinner from 'components/PageSpinner';
import AuthPage from 'pages/AuthPage';
import { BrowserRouter, Redirect, Switch, Route } from 'react-router-dom';

const ChangeAnotherUserPasswordPage = React.lazy(() => import('views/ChangeAnotherUserPasswordPage'));
const ChangePasswordPage = React.lazy(() => import('views/ChangePasswordPage'));
const DriversPage = React.lazy(() => import('views/DriversPage'));
const VehiclesPage = React.lazy(() => import('views/VehiclesPage'));
const TripHistory = React.lazy(() => import('views/TripHistory'));
const FuelingHistory = React.lazy(() => import('views/FuelingHistory'));
const VehicleBrandDashboard = React.lazy(() => import('views/VehicleBrandDashboard'));
const UsersPage = React.lazy(() => import('views/UsersPage'));
const OtsPage = React.lazy(() => import('views/OtsPage'));
const HomePage = React.lazy(() => import('views/HomePage'));
const OwnersPage = React.lazy(() => import('views/OwnersPage'));
const ConsumptionAnalisys = React.lazy(() => import('views/ConsumptionAnalisys'));
const TripUpdate = React.lazy(() => import('forms/TripUpdate'));
const FuelingUpdate = React.lazy(() => import('forms/FuelingUpdate'));
const DriverCreate = React.lazy(() => import('forms/DriverCreate'));
const DriverUpdate = React.lazy(() => import('forms/DriverUpdate'));
const UserCreate = React.lazy(() => import('forms/UserCreate'));
const UserUpdate = React.lazy(() => import('forms/UserUpdate'));
const OtCreate = React.lazy(() => import('forms/OtCreate'));
const OtUpdate = React.lazy(() => import('forms/OtUpdate'));
const VehicleUpdate = React.lazy(() => import('forms/VehicleUpdate'));
const VehicleCreate = React.lazy(() => import('forms/VehicleCreate'));
const ModelUpdate = React.lazy(() => import('forms/ModelUpdate'));
const ModelCreate = React.lazy(() => import('forms/ModelCreate'));
const BrandUpdate = React.lazy(() => import('forms/BrandUpdate'));
const BrandCreate = React.lazy(() => import('forms/BrandCreate'));
const OwnerUpdate = React.lazy(() => import('forms/OwnerUpdate'));
const OwnerCreate = React.lazy(() => import('forms/OwnerCreate'));
const TripRequestEdition = React.lazy(() => import('forms/TripRequestEdition'));
const FuelingRequestEdition = React.lazy(() => import('forms/FuelingRequestEdition'));
const TripComplete = React.lazy(() => import('forms/TripComplete'));
const VehicleTripHistory = React.lazy(() => import('views/VehicleTripHistory'));
const EditRequestDashboard = React.lazy(() => import('views/EditRequestDashboard'));
const TripCreate = React.lazy(() => import('forms/TripCreate'));
const TripCreateRequest = React.lazy(() => import('forms/TripCreateRequest'));
const FuelingCreateRequest = React.lazy(() => import('forms/FuelingCreateRequest'));
const CreateRequestDashboard = React.lazy(() => import('views/CreateRequestDashboard'));
const FuelingCreate = React.lazy(() => import('forms/FuelingCreate'));

const getBasename = () => {
  return ``;
};

class Routes extends Component {
  render() {
    const {user, loginState} = this.props;
    return (
      <BrowserRouter basename={getBasename()}>
          <GAListener>
            <Switch>
              <LayoutRoute
                exact
                path="/login"
                layout={EmptyLayout}
                component={props => (
                  <AuthPage {...props} authState={STATE_LOGIN} />
                )}
              />
              <LayoutRoute
                exact
                path="/signup"
                layout={EmptyLayout}
                component={props => (
                  <AuthPage {...props} authState={STATE_SIGNUP} />
                )}
              />
              <MainLayout>
                <React.Suspense fallback={<PageSpinner />}>
                  <ReadOnlyRoute exact path="/" user={user} isLoggedIn={loginState}>
                    <HomePage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/change_password" user={user} isLoggedIn={loginState}>
                    <ChangePasswordPage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/drivers" user={user} isLoggedIn={loginState}>
                    <DriversPage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/vehicles" user={user} isLoggedIn={loginState}>
                    <VehiclesPage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/work_orders" user={user} isLoggedIn={loginState}>
                    <OtsPage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/trip_history" user={user} isLoggedIn={loginState}>
                    <TripHistory/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/vehicle/:id/history" user={user} isLoggedIn={loginState}>
                    <VehicleTripHistory/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/fueling_history" user={user} isLoggedIn={loginState}>
                    <FuelingHistory/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path="/brands" user={user} isLoggedIn={loginState}>
                    <VehicleBrandDashboard/></ReadOnlyRoute>
                  <EditorsRoute exact path="/users" user={user} isLoggedIn={loginState}>
                    <UsersPage/></EditorsRoute>
                  <ReadOnlyRoute exact path="/consumption_analisys" user={user} isLoggedIn={loginState}>
                    <ConsumptionAnalisys/></ReadOnlyRoute>
                  <EditorsRoute exact path='/trip/:id'  user={user} isLoggedIn={loginState} readOnlyComponent={<TripRequestEdition/>}>
                    <TripUpdate/></EditorsRoute>
                  <EditorsRoute exact path='/fueling/:id' user={user} isLoggedIn={loginState} readOnlyComponent={<FuelingRequestEdition/>}>
                    <FuelingUpdate/></EditorsRoute>
                  <ReadOnlyRoute exact path='/driver/:id' user={user} isLoggedIn={loginState}>
                    <DriverUpdate/></ReadOnlyRoute>
                  <EditorsRoute exact path='/user/:id' user={user} isLoggedIn={loginState}>
                    <UserUpdate/></EditorsRoute>
                  <ReadOnlyRoute exact path='/vehicle/:id' user={user} isLoggedIn={loginState}>
                    <VehicleUpdate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/new_driver' user={user} isLoggedIn={loginState}>
                    <DriverCreate/></ReadOnlyRoute>
                  <EditorsRoute exact path='/new_user' user={user} isLoggedIn={loginState}>
                    <UserCreate/></EditorsRoute>
                  <ReadOnlyRoute exact path='/new_vehicle' user={user} isLoggedIn={loginState}>
                    <VehicleCreate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/new_work_order' user={user} isLoggedIn={loginState}>
                    <OtCreate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/work_order/:id' user={user} isLoggedIn={loginState}>
                    <OtUpdate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/model/:id' user={user} isLoggedIn={loginState}>
                    <ModelUpdate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/new_model/:id' user={user} isLoggedIn={loginState}>
                    <ModelCreate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/brand/:id' user={user} isLoggedIn={loginState}>
                    <BrandUpdate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/new_brand' user={user} isLoggedIn={loginState}>
                    <BrandCreate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/owner/:id' user={user} isLoggedIn={loginState}>
                    <OwnerUpdate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/new_owner' user={user} isLoggedIn={loginState}>
                    <OwnerCreate/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/owners' user={user} isLoggedIn={loginState}>
                    <OwnersPage/></ReadOnlyRoute>
                  <ReadOnlyRoute exact path='/trip/:id/complete' user={user} isLoggedIn={loginState}>
                    <TripComplete/></ReadOnlyRoute>
                  <Route exact path='/trip/:id/request_edition' component={TripRequestEdition}/>
                  <ReadOnlyRoute exact path='/user/:id/change_password/' user={user} isLoggedIn={loginState}>
                    <ChangeAnotherUserPasswordPage/></ReadOnlyRoute>
                  <EditorsRoute exact path='/edit_requests' user={user} isLoggedIn={loginState}>
                    <EditRequestDashboard/></EditorsRoute>
                  <EditorsRoute exact path='/create_requests' user={user} isLoggedIn={loginState}>
                    <CreateRequestDashboard/></EditorsRoute>
                  <EditorsRoute exact path="/new_trip" user={user} isLoggedIn={loginState} readOnlyComponent={<TripCreateRequest/>}>
                    <TripCreate/></EditorsRoute>
                  <EditorsRoute exact path="/new_fueling" user={user} isLoggedIn={loginState} readOnlyComponent={<FuelingCreateRequest/>}>
                    <FuelingCreate/></EditorsRoute>
                </React.Suspense>
              </MainLayout>
              <Redirect to="/" />
            </Switch>
          </GAListener>
        </BrowserRouter>);
  }
}

const mapStateToProps = state => ({
    loginState: state.auth.isLoggedIn,
    user:state.auth.user
  });

export default connect(mapStateToProps)(Routes);
